import "../../../App.css";
import React, {useCallback, useEffect, useState} from "react";
import {Button, Descriptions, Form, Input, Layout, message, Modal, Radio, Result, Typography} from "antd";
import "antd/dist/reset.css";
import useAxios from "axios-hooks";
import {CheckoutSubmissionRequest} from "../../../types/CheckoutSubmissionRequest";
import {useOrderId} from "../../../hooks/UseOrderId";
import {PaymentType} from "../../../App";
import {CardTypeEnum} from "../../../types/CardTypeEnum";
import {CheckoutStatusResult} from "../../../types/CheckoutStatusResult";
import {ProviderTypeEnum} from "../../../types/ProviderTypeEnum";
import {Copyable} from "../../common/Copyable";
import WrappedCard from "../../antd/WrappedCard";
import easypaisaLogo from "../../../assets/easypaisa-logo3.png";
import jazzcashLogo from "../../../assets/jazzcash-logo2.png";
import bankCardLogo from "../../../assets/bankcard-logo.png";
import loadingGif from "../../../assets/background/share/loading.gif";
import failLogo from "../../../assets/background/PkDynamicWalletRequestDemoV2Mode/fail.png";
import teachingVideo from "../../../assets/bankCardTeching.mp4";
import "./PkDynamicWalletRequestMobileV2Mode.css";
import IntentApp from "../shared/IntentApp";
import IntentAppFirstPay from "../shared/IntentAppFirstPay";

const {Content} = Layout;

const ignore = false;
const OverdueTime = 3 * 60 * 1000;
const PollingTime = 5 * 1000;

// NOTICE: GET目前是同步的，后面有可能会需要支援非同步，近来收银台后先转圈等到GET有结果
function PkDynamicWalletRequestMobileV2Mode({getCheckoutInfoData}: PaymentType) {
    const id = useOrderId();

    const [{data: putData}, executePost] =
        useAxios<CheckoutSubmissionRequest>(
            {
                url: `/v2/checkout/${id}`,
                method: "POST"
            },
            {manual: true}
        );
    console.log("[POST] checkout.putData", putData);

    const [
        {
            data: getCheckoutResultData,
            loading: pollingLoading
        },
        pollingCheckoutResult
    ] = useAxios<CheckoutStatusResult>(`/v2/orders/${id}`);

    const [submitCheckout, setSubmitCheckout] = useState(getCheckoutInfoData?.checkoutStatus === "SUBMITTED");
    const [cardSubmitCheckout, setCardSubmitCheckout] = useState(getCheckoutInfoData?.checkoutStatus === "SUBMITTED");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitCheckoutIsFail, setSubmitCheckoutIsFail] = useState(false);
    const [providerName] = useState(
        getCheckoutInfoData?.defaultChannel === "easypaisa" ? CardTypeEnum.EasyPaisa :
            getCheckoutInfoData?.defaultChannel === "jazzcash" ? CardTypeEnum.JazzCash :
                getCheckoutInfoData?.defaultChannel === "jazzcash_v2" ? CardTypeEnum.JazzCashV2 :
                    getCheckoutInfoData?.defaultChannel === "ajar:easypaisa" ? CardTypeEnum.AjarToEasyPaisa :
                        getCheckoutInfoData?.defaultChannel === "ajar:jazzcash" ? CardTypeEnum.AjarToJazzCash :
                            getCheckoutInfoData?.defaultChannel === "card_group:bank" ? CardTypeEnum.BankCard :
                                getCheckoutInfoData?.defaultChannel === "card_group:sadapay" ? CardTypeEnum.SadapayCard :
                                    getCheckoutInfoData?.defaultChannel === "card_group:opay" ? CardTypeEnum.OpayCard :
                                        null);
    const [form] = Form.useForm();
    const [isFormValid, setIsFormValid] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [showWalletHintModal, setShowWalletHintModal] = useState(true);
    const [showBankCardHintModal, setShowBankCardHintModal] = useState(false);
    const [countDownText, setCountDownText] = useState("Ready countdown");
    const [neverCountDown, setNeverCountDown] = useState(true);
    const [showIntentAppHintModal, setShowIntentAppHintModal] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(getCheckoutInfoData?.automaticSubmission);

    // 是否是钱包
    const [isWallet, setIsWallet] = useState(false);
    const [isAjar, setIsAjar] = useState(false);
    const [isJazzcash, setIsJazzcash] = useState(false);
    const [isJazzcashV1, setIsJazzcashV1] = useState(false);
    const [isJazzcashV2, setIsJazzcashV2] = useState(false);
    const [isEasypaisa, setIsEasypaisa] = useState(false);

    // 是否是卡片
    const [isCard, setIsCard] = useState(false);
    const [isBankCard, setIsBankCard] = useState(false);
    const [isSadapayCard, setIsSadapayCard] = useState(false);
    const [isOapayCard, setIsOpayCard] = useState(false);

    const onFormFinish = (values: any) => {
        setSubmitCheckout(true);
        if (isCard) {
            setCardSubmitCheckout(true);
        }

        // NOTICE: 三分截止
        startOverdueCountDown();

        if (!ignore) {
            let newProviderName;
            let newReserved1;
            switch (values.providerName) {
                case CardTypeEnum.AjarToEasyPaisa:
                    newProviderName = CardTypeEnum.Ajar;
                    newReserved1 = CardTypeEnum.EasyPaisa;
                    break;
                case CardTypeEnum.AjarToJazzCash:
                    newProviderName = CardTypeEnum.Ajar;
                    newReserved1 = CardTypeEnum.JazzCash;
                    break;
                default:
                    newProviderName = values.providerName;
                    newReserved1 = getCheckoutInfoData?.reserved1;
                    break;
            }

            executePost({
                data: {
                    id: id,
                    providerType: ProviderTypeEnum.WALLET,
                    providerName: newProviderName,
                    customerAccount: values.customerAccount,
                    customerIdCard: values.customerIdCard,
                    customerName: values.customerName,
                    reserved1: newReserved1,
                    reserved2: getCheckoutInfoData?.reserved2,
                    automaticSubmission:getCheckoutInfoData?.automaticSubmission
                }
            })
                .then(() => {
                    setSubmitCheckout(true);
                })
                .catch((error) => {
                    setSubmitCheckoutIsFail(true);
                    messageApi.error("Failed:" + error?.response?.data?.title);
                })
                .finally(() => {
                });
        }
    };

    const onButtonClick = () => {
        setIsSubmitting(true);
        form.submit();
        setShowIntentAppHintModal(true);
    };

    const refreshPayType = () => {
        refreshField();
        checkFormValidity();
    }

    // 依照选项显示不同的内容
    const refreshField = () => {
        let cardType = form.getFieldValue("providerName");

        setIsWallet(false);
        setIsAjar(false);
        setIsJazzcash(false);
        setIsJazzcashV1(false);
        setIsJazzcashV2(false);
        setIsEasypaisa(false);

        setIsCard(false);
        setIsBankCard(false);
        setIsSadapayCard(false);
        setIsOpayCard(false);

        if (cardType === CardTypeEnum.AjarToEasyPaisa || cardType === CardTypeEnum.AjarToJazzCash) {
            setIsWallet(true);
            setIsAjar(true);
        } else if (cardType === CardTypeEnum.JazzCash) {
            setIsWallet(true);
            setIsJazzcash(true);
            setIsJazzcashV1(true);
        } else if (cardType === CardTypeEnum.JazzCashV2) {
            setIsWallet(true);
            setIsJazzcash(true);
            setIsJazzcashV2(true);
        } else if (cardType === CardTypeEnum.EasyPaisa) {
            setIsWallet(true);
            setIsEasypaisa(true);
        } else if (cardType === CardTypeEnum.BankCard) {
            setIsCard(true);
            setIsBankCard(true);
        } else if (cardType === CardTypeEnum.SadapayCard) {
            setIsCard(true);
            setIsSadapayCard(true);
        } else if (cardType === CardTypeEnum.OpayCard) {
            setIsCard(true);
            setIsOpayCard(true);
        }
    }

    const checkFormValidity = () => {
        form.validateFields()
            .then(() => {
                setIsFormValid(true);
            })
            .catch(() => {
                setIsFormValid(false);
            });
    }

    const [isOverdueTime, setIsOverdueTime] = useState<boolean>(false);
    console.log("0.isOverdueTime", isOverdueTime);

    // NOTICE: 十秒輪詢 way1
    useEffect(() => {
        const stoppingStatuses: string[] = ["SUCCESS", "FAIL"]

        let pollingCountDown: NodeJS.Timeout;
        if (isOverdueTime) {
            console.log(
                "[Polling] Cause overdue time , so no need to process to poll"
            );
        } else if (!submitCheckout) {
            refreshPayType();
            console.log("[Polling] no need to process to poll");
        } else {
            console.log("[Polling] pollingLoading", pollingLoading);
            if (getCheckoutResultData?.status === "PROCESSING") {
                console.log("[Polling] restart to polling");
                if (neverCountDown) {
                    setNeverCountDown(false);
                    submitCountDown();
                }

                pollingCountDown = setTimeout(function () {
                    pollingCheckoutResult()
                        .then((data) => {
                            console.log("[Polling] end to polling.data", data);
                        })
                        .catch((error) => {
                            console.log("[Polling] restart to polling.error", error);
                        })
                        .finally(() => {
                        });
                }, PollingTime);
            } else if (typeof getCheckoutResultData !== "undefined" && stoppingStatuses.includes(getCheckoutResultData.status)) {
                console.log("[Polling] end to polling.data", getCheckoutResultData);
                messageApi.info("Result: " + getCheckoutResultData.status);
            }
        }
        return () => {
            if (pollingCountDown) clearTimeout(pollingCountDown);
        };
    }, [submitCheckout, pollingLoading, isOverdueTime, getCheckoutResultData]);

    useEffect(() => {
        if (!submitCheckout && isSubmitted) {
            setIsSubmitted(false);
            onFormFinish({
                providerName: getCheckoutInfoData?.defaultChannel,
                customerAccount: getCheckoutInfoData?.receiverAccount,
                customerIdCard: getCheckoutInfoData?.receiverIdCard,
                customerName: getCheckoutInfoData?.receiverName,
            });
            setIsSubmitting(true);
            setShowIntentAppHintModal(true);
        }
    }, [isSubmitted]);

    // NOTICE: 三分截止
    let countDown: NodeJS.Timeout;
    const startOverdueCountDown = useCallback(() => {
        console.log("[CountDown] start to count down");
        countDown = setTimeout(function () {
            console.log("[CountDown] end to count down");
            setIsOverdueTime(true);
        }, OverdueTime);
    }, []);

    const clearOverdueCountDown = () => {
        clearTimeout(countDown);
    };
    useEffect(() => {
        return () => {
            clearOverdueCountDown();
        };
    });

    const submitCountDown = () => {
        let num = (isJazzcash) ? 120 : ((isEasypaisa) ? 40 : 60);
        setCountDownText(formatTime(num));
        let timer = setInterval(() => {
            num--;
            setCountDownText(formatTime(num));
            if (num === 0) {
                setCountDownText("Time's Up !!!");
                clearInterval(timer);
            }
        }, 1000);
    };

    const formatTime = (seconds: number) => {
        let minutes = Math.floor(seconds / 60);
        let remainingSeconds = seconds % 60;
        return `${padZero(minutes)}:${padZero(remainingSeconds)}`;
    };

    const padZero = (num: number) => {
        return num < 10 ? `0${num}` : `${num}`;
    };

    return (
        <>
            {contextHolder}
            {/*NOTICE: 訂單未完成*/}
            {!cardSubmitCheckout && !submitCheckoutIsFail && getCheckoutResultData?.status !== "SUCCESS" && (
                <Content>
                    {/*钱包使用说明弹出视窗*/}
                    {/*<Modal*/}
                    {/*    open={(isWallet && showWalletHintModal)}*/}
                    {/*    closable={false}*/}
                    {/*    onOk={() => {*/}
                    {/*        setShowWalletHintModal(false)*/}
                    {/*    }}*/}
                    {/*    onCancel={() => {*/}
                    {/*        setShowWalletHintModal(false)*/}
                    {/*    }}*/}
                    {/*    okText="Confirm"*/}
                    {/*>*/}
                    {/*    <WrappedCard cardTitle="Important:">*/}
                    {/*        <>*/}
                    {/*            Please enter genuine & verifiable CNIC number and your wallet*/}
                    {/*            account number & follow below steps. <br/>*/}
                    {/*            Step 1: Receive a notification for the transaction. <br/>*/}
                    {/*            Step 2: Open the EasyPaisa / JazzCash app and sign in. <br/>*/}
                    {/*            Step 3: Find the "Payment Requests" in JazzCash or "My*/}
                    {/*            Approvals" in EasyPaisa. <br/>*/}
                    {/*            Step 4: Accept the transaction request.*/}
                    {/*        </>*/}
                    {/*    </WrappedCard>*/}

                    {/*    <WrappedCard cardTitle={*/}
                    {/*        <>*/}
                    {/*            <div style={{textAlign: "right", width: "100%", direction: "rtl"}}>ضروری احکامات:*/}
                    {/*            </div>*/}
                    {/*        </>*/}
                    {/*    }>*/}
                    {/*        <>*/}
                    {/*            <div style={{textAlign: "right", width: "100%", direction: "rtl"}}>*/}
                    {/*                تصدیق یافتہ شناختی کارڈ اور والٹ اکاؤنٹ درج کرنا ضروری ہے۔*/}
                    {/*                <br/>*/}
                    {/*                اِس کے بعد نیچے دی گئی ہدایات پر عمل کریں*/}
                    {/*                <br/>*/}
                    {/*                ۱۔ ٹرانزیکشن کا نوٹیفکیشن حاصل کریں۔*/}
                    {/*                <br/>*/}
                    {/*                ۲۔ EasyPasia یا JazzCash کی ایپ کھولیں اور سائن ان کریں۔*/}
                    {/*                <br/>*/}
                    {/*                ۳۔ آپ JazzCash کسٹمر ہیں تو "Payment Requests" اور EasyPaisa*/}
                    {/*                کسٹمر ہیں تو "My Approvals" تلاش کریں۔*/}
                    {/*                <br/>*/}
                    {/*                ۴۔ ٹرانزیکشن کی درخواست قبول کریں۔*/}
                    {/*            </div>*/}
                    {/*        </>*/}
                    {/*    </WrappedCard>*/}
                    {/*</Modal>*/}

                    <header className="dwrd2-header">
                        <div className="dwrd2-header-font">Deposit</div>
                        <div className="dwrd2-amount-container">
                            <div className="dwrd2-amount-content">
                                <div className="dwrd2-amount">
                                    Rs {getCheckoutInfoData?.orderAmount}.00
                                </div>
                                <div className="dwrd2-amount-currency">
                                    Payment Amount
                                </div>
                                <div className="dwrd2-amount-currency-arabic">
                                    ادائیگی کی رقم
                                </div>
                            </div>
                        </div>
                    </header>

                    <WrappedCard cardProps={{className: "dwrd2-payment-container"}}>
                        <Form
                            form={form}
                            initialValues={{providerName}}
                            onFinish={onFormFinish}
                            onChange={refreshPayType}
                        >
                            <>
                                <div className="dwrd2-form-amount">
                                    <span className="dwrd2-form-amount-currency">Payment Type</span>
                                    <span className="dwrd2-form-amount-currency-arabic">ادائیگی کی قسم</span>
                                </div>
                                <Form.Item name="providerName" className="dwrd2-form-item">
                                    <Radio.Group className="dwrd2-radio-group" name="providerName">
                                        {getCheckoutInfoData?.availableChannels.includes("easypaisa") && (
                                            <Radio.Button value={CardTypeEnum.EasyPaisa}
                                                          className="dwrd2-radio-button">
                                                <div className="dwrd2-form-item-img">
                                                    <img src={easypaisaLogo} alt="Easypaisa-a"
                                                         className="dwrd2-form-item-img-easypaisa"/>
                                                    <span className="dwrd2-image-text-easypaisa">easypaisaa</span>
                                                </div>
                                            </Radio.Button>
                                        )}
                                        {getCheckoutInfoData?.availableChannels.includes("jazzcash") && (
                                            <Radio.Button value={CardTypeEnum.JazzCash}
                                                          className="dwrd2-radio-button">
                                                <div className="dwrd2-form-item-img">
                                                    <img src={jazzcashLogo} alt="Jazzcash"
                                                         className="dwrd2-form-item-img-jazzcash"/>
                                                    <span className="dwrd2-image-text-jazzcash">jazzcash </span>
                                                </div>
                                            </Radio.Button>
                                        )}
                                        {getCheckoutInfoData?.availableChannels.includes("jazzcash_v2") && (
                                            <Radio.Button value={CardTypeEnum.JazzCashV2}
                                                          className="dwrd2-radio-button">
                                                <div className="dwrd2-form-item-img">
                                                    <img src={jazzcashLogo} alt="Jazzcash"
                                                         className="dwrd2-form-item-img-jazzcash"/>
                                                    <span className="dwrd2-image-text-jazzcash">jazzcash </span>
                                                </div>
                                            </Radio.Button>
                                        )}
                                        {getCheckoutInfoData?.availableChannels.includes("ajar:easypaisa") && (
                                            <Radio.Button value={CardTypeEnum.AjarToEasyPaisa}
                                                          className="dwrd2-radio-button">
                                                <div className="dwrd2-form-item-img">
                                                    <img src={easypaisaLogo} alt="Easypaisa-a"
                                                         className="dwrd2-form-item-img-easypaisa"/>
                                                    <span className="dwrd2-image-text-easypaisa">easypaisa</span>
                                                </div>
                                            </Radio.Button>
                                        )}
                                        {getCheckoutInfoData?.availableChannels.includes("ajar:jazzcash") && (
                                            <Radio.Button value={CardTypeEnum.AjarToJazzCash}
                                                          className="dwrd2-radio-button">
                                                <div className="dwrd2-form-item-img">
                                                    <img src={jazzcashLogo} alt="Jazzcash"
                                                         className="dwrd2-form-item-img-jazzcash"/>
                                                    <span className="dwrd2-image-text-jazzcash">jazzcash</span>
                                                </div>
                                            </Radio.Button>
                                        )}
                                        {getCheckoutInfoData?.availableChannels.includes("card_group:bank") && (
                                            <Radio.Button value={CardTypeEnum.BankCard}
                                                          className="dwrd2-radio-button">
                                                <img src={bankCardLogo} alt="card"/>
                                            </Radio.Button>
                                        )}
                                        {getCheckoutInfoData?.availableChannels.includes("card_group:sadapay") && (
                                            <Radio.Button value={CardTypeEnum.SadapayCard}
                                                          className="dwrd2-radio-button">
                                                <img src={bankCardLogo} alt="card"/>
                                            </Radio.Button>
                                        )}
                                        {getCheckoutInfoData?.availableChannels.includes("card_group:opay") && (
                                            <Radio.Button value={CardTypeEnum.OpayCard}
                                                          className="dwrd2-radio-button">
                                                <img src={bankCardLogo} alt="card"/>
                                            </Radio.Button>
                                        )}
                                    </Radio.Group>
                                </Form.Item>
                                <div className="dwrd2-form-container">
                                    <div className="dwrd2-input-container-demo">
                                        <hr className="dwrd2-hr"/>
                                    </div>
                                </div>


                                <div className="dwrd2-form-container">
                                    <div className="dwrd2-input-container">
                                        {isAjar && (
                                            <>
                                                <div className="dwrd2-input-label">
                                                    <span
                                                        className="dwrd2-form-amount-currency">Wallet Account Number</span>
                                                    <span className="dwrd2-form-amount-currency-arabic">والیٹ اکاؤنٹ نمبر</span>
                                                </div>
                                                <Form.Item
                                                    name="customerAccount"
                                                    className="dwrd2-form-rules-fail"
                                                    rules={[{
                                                        required: true,
                                                        message: "account should be an integer starting with 3 and totaling ten digits."
                                                    }]}
                                                    initialValue={getCheckoutInfoData?.receiverAccount}
                                                >
                                                    <Input className="dwrd2-input-field"
                                                           placeholder="eg. 0000-0000000"/>
                                                </Form.Item>

                                                <div className="dwrd2-input-label">
                                                    <span className="dwrd2-form-amount-currency">CNIC</span>
                                                    <span
                                                        className="dwrd2-form-amount-currency-arabic">شناختی کارڈ</span>
                                                </div>
                                                <Form.Item
                                                    name="customerIdCard"
                                                    className="dwrd2-form-rules-fail"
                                                    rules={[{
                                                        required: true,
                                                        message: "CNIC should be real CNIC number and thirteen digital integer."
                                                    }]}
                                                    initialValue={getCheckoutInfoData?.receiverIdCard}
                                                >
                                                    <Input className="dwrd2-input-field"
                                                           placeholder="eg. 35134-0000000-0"/>
                                                </Form.Item>
                                            </>
                                        )}
                                        {isJazzcashV1 && (
                                            <>
                                                <div className="dwrd2-input-label">
                                                    <span
                                                        className="dwrd2-form-amount-currency">Wallet Account Number</span>
                                                    <span className="dwrd2-form-amount-currency-arabic">والیٹ اکاؤنٹ نمبر</span>
                                                </div>
                                                <Form.Item
                                                    name="customerAccount"
                                                    className="dwrd2-form-rules-fail"
                                                    rules={[{
                                                        required: true,
                                                        message: "account should be an integer starting with 3 and totaling ten digits."
                                                    }]}
                                                    initialValue={getCheckoutInfoData?.receiverAccount}
                                                >
                                                    <Input className="dwrd2-input-field"
                                                           placeholder="eg. 0000-0000000">
                                                    </Input>
                                                </Form.Item>

                                                <div className="dwrd2-input-label">
                                                    <span className="dwrd2-form-amount-currency">CNIC</span>
                                                    <span
                                                        className="dwrd2-form-amount-currency-arabic">شناختی کارڈ</span>
                                                </div>
                                                <Form.Item
                                                    name="customerIdCard"
                                                    className="dwrd2-form-rules-fail"
                                                    rules={[{
                                                        required: true,
                                                        message: "CNIC should be real CNIC number and thirteen digital integer."
                                                    }]}
                                                    initialValue={getCheckoutInfoData?.receiverIdCard}
                                                >
                                                    <Input className="dwrd2-input-field"
                                                           placeholder="eg. 35134-0000000-0"/>
                                                </Form.Item>
                                            </>
                                        )}
                                        {isJazzcashV2 && (
                                            <>
                                                <div className="dwrd2-input-label">
                                                    <span
                                                        className="dwrd2-form-amount-currency">Wallet Account Number</span>
                                                    <span className="dwrd2-form-amount-currency-arabic">والیٹ اکاؤنٹ نمبر</span>
                                                </div>
                                                <Form.Item
                                                    name="customerAccount"
                                                    className="dwrd2-form-rules-fail"
                                                    rules={[{
                                                        required: true,
                                                        message: "account should be an integer starting with 3 and totaling ten digits."
                                                    }]}
                                                    initialValue={getCheckoutInfoData?.receiverAccount}
                                                >
                                                    <Input className="dwrd2-input-field"
                                                           placeholder="eg. 0000-0000000"/>
                                                </Form.Item>
                                            </>
                                        )}
                                        {isEasypaisa && (
                                            <>
                                                <div className="dwrd2-input-label">
                                                    <span
                                                        className="dwrd2-form-amount-currency">Wallet Account Number</span>
                                                    <span className="dwrd2-form-amount-currency-arabic">والیٹ اکاؤنٹ نمبر</span>
                                                </div>
                                                <Form.Item
                                                    name="customerAccount"
                                                    className="dwrd2-form-rules-fail"
                                                    rules={[{
                                                        required: true,
                                                        message: "account should be an integer starting with 3 and totaling ten digits."
                                                    }]}
                                                    initialValue={getCheckoutInfoData?.receiverAccount}
                                                >
                                                    <Input className="dwrd2-input-field"
                                                           placeholder="eg. 0000-0000000"/>
                                                </Form.Item>
                                            </>
                                        )}

                                        {/*银行卡收说明*/}
                                        {isBankCard && (
                                            <WrappedCard cardTitle="Information">
                                                <>
                                                    <div style={{fontSize: 16, color: "blue", width: "100%"}}>
                                                        Step 1. Please use bank card to transfer to the following
                                                        bank card <br/>
                                                        Step 2. Fill in payment information <br/>
                                                        Step 3. Submit <br/>
                                                        <Button style={{
                                                            fontSize: 16,
                                                            color: "white",
                                                            background: "#1677ff",
                                                            textAlign: "center"
                                                        }} onClick={() => {
                                                            setShowBankCardHintModal(true)
                                                        }}>How to do it?</Button>
                                                        <Modal
                                                            open={showBankCardHintModal}
                                                            closable={false}
                                                            onOk={() => {
                                                                setShowBankCardHintModal(false)
                                                            }}
                                                            onCancel={() => {
                                                                setShowBankCardHintModal(false)
                                                            }}
                                                        >
                                                            <video controls width="100%">
                                                                <source src={teachingVideo} type="video/mp4"/>
                                                                Your browser does not support the video tag.
                                                            </video>
                                                        </Modal>
                                                        <br/>
                                                    </div>
                                                </>
                                            </WrappedCard>
                                        )}

                                        {/* Sadapay卡收说明*/}
                                        {isSadapayCard && (
                                            <WrappedCard cardTitle="Information">
                                                <>
                                                    <div style={{fontSize: 16, color: "blue", width: "100%"}}>
                                                        Step 1. Fill in payment information <br/>
                                                        Step 2. Submit <br/>
                                                        Step 3. Please transfer fund to the following SadaPay
                                                        account <br/>
                                                    </div>
                                                </>
                                            </WrappedCard>
                                        )}

                                        {/* Opay卡收说明*/}
                                        {isOapayCard && (
                                            <WrappedCard cardTitle="Information">
                                                <>
                                                    <div style={{fontSize: 16, color: "blue", width: "100%"}}>
                                                        Step 1. Fill in payment information <br/>
                                                        Step 2. Submit <br/>
                                                        Step 3. Please transfer fund to the following OPay
                                                        account <br/>
                                                    </div>
                                                </>
                                            </WrappedCard>
                                        )}

                                        {isCard && (
                                            <>
                                                <div className="dwrd2-input-label">
                                                    <span
                                                        className="dwrd2-form-amount-currency">Wallet account name</span>
                                                    <span className="dwrd2-form-amount-currency-arabic">والیٹ اکاؤنٹ کا نام</span>
                                                </div>
                                                <Form.Item
                                                    name="customerName"
                                                    className="dwrd2-form-rules-fail"
                                                    rules={[{
                                                        required: true,
                                                        message: "Please insert correct name"
                                                    }]}
                                                    initialValue={getCheckoutInfoData?.receiverName}
                                                >
                                                    <Input className="dwrd2-input-field"
                                                           placeholder="eg. 0000-0000000"/>
                                                </Form.Item>

                                                <div className="dwrd2-input-label">
                                                    <span
                                                        className="dwrd2-form-amount-currency">Wallet Account Number</span>
                                                    <span className="dwrd2-form-amount-currency-arabic">والیٹ اکاؤنٹ نمبر</span>
                                                </div>
                                                <Form.Item
                                                    name="customerAccount"
                                                    className="dwrd2-form-rules-fail"
                                                    rules={[{
                                                        required: true,
                                                        message: "account should be an integer starting with 3 and totaling ten digits."
                                                    }]}
                                                    initialValue={getCheckoutInfoData?.receiverAccount}
                                                >
                                                    <Input className="dwrd2-input-field"
                                                           placeholder="eg. 35134-0000000-0"/>
                                                </Form.Item>
                                            </>
                                        )}
                                    </div>

                                    <Form.Item>
                                        <div className="dwrd2-submit-button-container">
                                            <Button type="primary"
                                                    className="dwrd2-submit-button"
                                                    onClick={onButtonClick}
                                                    disabled={!isFormValid || isSubmitting}>
                                                {isSubmitting ? (
                                                    <>
                                                        <img
                                                            src={loadingGif}
                                                            alt="loading"
                                                            style={{width: "24px", height: "24px"}}
                                                        />
                                                        <span className="dwrd2-submit-button-font">Continue</span>
                                                    </>
                                                ) : (<span className="dwrd2-submit-button-font">Continue</span>)}
                                            </Button>
                                        </div>
                                    </Form.Item>
                                </div>
                            </>
                        </Form>
                        <p className="dwrd2-footer-text">
                            After the transaction please open your wallet
                        </p>
                        <p className="dwrd2-footer-text-arabic">
                            لین دین کے بعد براہ کرم اپنا بٹوہ کھولیں۔
                        </p>
                    </WrappedCard>
                </Content>
            )}

            {submitCheckoutIsFail && (
                // <Result
                //     status="info"
                //     title={
                //         <>
                //             <div style={{textAlign: "center", color: "red"}}>
                //                 Submission Unsuccessful<br/>
                //             </div>
                //             <div>
                //                 Please check back later and try this transaction again.<br/>
                //             </div>
                //             <div>
                //                 براہ کرم بعد میں دوبارہ آئیں اور اس لین دین کو دوبارہ کوشش کریں۔
                //             </div>
                //         </>
                //     }
                // />
                <div className="dwrd2-submit-fail-page">
                    <div className="dwrd2-submit-fail-page2">
                        <div className="dwrd2-submit-fail-logo-page">
                            <div className="dwrd2-submit-fail-logo">
                                <img src={failLogo} alt="failLogo"/>
                            </div>

                            <div className="dwrd2-submit-fail-title-page">
                                <div className="dwrd2-submit-fail-title">
                                    Submission
                                </div>
                                <div className="dwrd2-submit-fail-title">
                                    Failed
                                </div>
                            </div>
                        </div>

                        <div className="dwrd2-submit-fail-text">
                            Please return later and retry the transaction.
                        </div>
                        <div className="dwrd2-submit-fail-text-arabic">
                            جمع کرانے میں ناکامی براہ کرم بعد میں واپس آئیں اور اس لین دین کی دوبارہ کوشش کریں۔
                        </div>
                    </div>
                </div>
            )}


            {/*/!*NOTICE: 系統超過三分鐘後，使用者會看到訂單有問題之類訊息(後端之後會動態調整文案)。*!/*/}
            {/*{submitCheckout && isWallet &&*/}
            {/*    isOverdueTime &&*/}
            {/*    getCheckoutResultData?.status === "PROCESSING" && (*/}
            {/*        <Result*/}
            {/*            status="warning"*/}
            {/*            title="We have not received your payment yet. If the transaction is delayed, please reach out to customer service if there is no further progress within two hours."*/}
            {/*        />*/}
            {/*    )}*/}

            {/*卡收提交后画面*/}
            {submitCheckout && isCard && (
                <Descriptions title={
                    <>
                        <table width="100%" className="dwrd2-custom-table">
                            <tbody>
                            <tr>
                                <td className="dwrd2-form-amount-currency">Card Information</td>
                                <td align="right" className="dwrd2-form-amount-currency-arabic">بینک کی معلومات</td>
                            </tr>
                            </tbody>
                        </table>
                    </>
                } bordered>
                    <Descriptions.Item label={
                        <>
                            Amount<br/>
                            قابل ادائیگی رقم
                        </>
                    }>
                        <Typography.Title
                            copyable={{icon: <Copyable/>}}
                            level={5}
                            style={{margin: 0}}
                        >
                            {getCheckoutInfoData?.orderAmount}
                        </Typography.Title>
                    </Descriptions.Item>

                    <Descriptions.Item label={
                        <>
                            Bank Account<br/>
                            بینک اکاؤنٹ
                        </>
                    }>
                        <Typography.Title
                            copyable={{icon: <Copyable/>}}
                            level={5}
                            style={{margin: 0}}
                        >
                            {getCheckoutInfoData?.cardReceiverAccount}
                        </Typography.Title>
                    </Descriptions.Item>

                    <Descriptions.Item label={
                        <>
                            Bank Name<br/>
                            بینک کا نام
                        </>
                    }>
                        <Typography.Title
                            copyable={{icon: <Copyable/>}}
                            level={5}
                            style={{margin: 0}}
                        >
                            {getCheckoutInfoData?.cardReceiverBankName}
                        </Typography.Title>
                    </Descriptions.Item>

                    {getCheckoutInfoData?.receiverBranchBank && (<Descriptions.Item label={
                        <>
                            Branch Bank Name<br/>
                            بینک برانچ کا نام
                        </>
                    }>
                        <Typography.Title
                            copyable={{icon: <Copyable/>}}
                            level={5}
                            style={{margin: 0}}
                        >
                            {getCheckoutInfoData?.cardReceiverBankBranchName}
                        </Typography.Title>
                    </Descriptions.Item>)}

                    <Descriptions.Item label={
                        <>
                            Account Name<br/>
                            کھاتے کا نام
                        </>
                    }>
                        <Typography.Title
                            copyable={{icon: <Copyable/>}}
                            level={5}
                            style={{margin: 0}}
                        >
                            {getCheckoutInfoData?.cardReceiverName}
                        </Typography.Title>
                    </Descriptions.Item>
                </Descriptions>
            )}
            {showIntentAppHintModal && <IntentAppFirstPay providerName={form.getFieldValue("providerName")}/>}
        </>
    );
}

export default PkDynamicWalletRequestMobileV2Mode;
